export abstract class ExternalStore<T> {
  protected listeners = new Set<() => void>();
  abstract getSnapshot: () => T;
  subscribe = (callback: () => void) => {
    this.listeners.add(callback);
    return () => {
      this.listeners.delete(callback);
    };
  };
  protected notify() {
    this.listeners.forEach((listener) => listener());
  }
}
